import * as React from 'react'
import { Box } from "@mui/material"

import { SkuInfoBlock } from "@components"


export default function skuColumn() {
	return {
		name: 'sku', label: 'Product Name',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { category, brand, ean }) => <Box>
				<SkuInfoBlock sku={value} category={category} brand={brand} ean={ean} />
			</Box>
		}
	}
}